import { Outlet } from 'react-router-dom'
import FollowupsTabs from './_components/followups-tabs.component'
import CurrentPatientFile from './_components/patient-file.provider'
import { useParams } from 'react-router-dom'

export default function PatientFileLayout() {
  const params = useParams()
  const projectId = Number(params.projectId)
  const patientId = Number(params.patientId)

  return (
    <CurrentPatientFile projectId={projectId} patientId={patientId}>
      <FollowupsTabs />
      <Outlet />
    </CurrentPatientFile>
  )
}
